import {Component, Injectable} from '@angular/core';
import {LoginPage} from '../pages/login/login';
import {ErrorPage} from '../pages/error/error';
import {PurchasePage} from '../pages/purchase/purchase';
import {Config} from '../app/app.config';

@Injectable()
export class RouteInfo{

  routeType:string;
  routeTarget:any;

  constructor(routeType, routeTarget){
    this.routeType = routeType;
    this.routeTarget = routeTarget;
  }

}

@Injectable()
export class Router {

  routeInStoreDeferred(config:any){
    var params = [];
    params["client_cd"] = this.getUrlParameter("client_cd");
    params["store_id"] = this.getUrlParameter("store_id");
    params["loc"] = this.getUrlParameter("loc");
    params["table_id"] = this.getUrlParameter("table_id");
    params["debug"] = this.getUrlParameter("debug");
    params["menubook_id"] = this.getUrlParameter("menubook_id");
    
    var locals = [];
    locals["client_cd"] = localStorage.getItem("client_cd");
    locals["store_id"] = localStorage.getItem("store_id");
    locals["table_id"] = localStorage.getItem("table_id");
    locals["loc"] = localStorage.getItem("loc");
    locals["debug"] = localStorage.getItem("debug");
    
    if (params["client_cd"] && params["store_id"] && params["table_id"]) {
      // set params
      localStorage.setItem("client_cd", params["client_cd"]);
      localStorage.setItem("store_id", params["store_id"]);
      localStorage.setItem("table_id", params["table_id"]);
      if (params["loc"]){
        localStorage.setItem("loc", params["loc"]);
      }
      else{
        localStorage.removeItem("loc");
      }
      if (params["menubook_id"]) {
        localStorage.setItem("menubook_id", params["menubook_id"]);
      } else {
        localStorage.removeItem("menubook_id");
      }
        
      return new RouteInfo("redirect", location.protocol + '//' + location.host + location.pathname + "?v=" + Config.version);
    }
    else if (params["client_cd"] && params["store_id"]) {
      // set params
      localStorage.setItem("client_cd", params["client_cd"]);
      localStorage.setItem("store_id", params["store_id"]);
      localStorage.removeItem("visitor_id");
      if (params["loc"]){
        localStorage.setItem("loc", params["loc"]);
      }
      else{
        localStorage.removeItem("loc");
      }
      if (params["menubook_id"]) {
        localStorage.setItem("menubook_id", params["menubook_id"]);
      } else {
        localStorage.removeItem("menubook_id");
      }  
      
      return new RouteInfo("redirect", location.protocol + '//' + location.host + location.pathname + "?v=" + Config.version);
    }

    if (!locals["client_cd"] || !locals["store_id"] || !locals["table_id"]) {
      //       Error
      return new RouteInfo("page", ErrorPage);
    }
    return null;
  }

  routeInStore(config:any){
    var params = [];
    params["client_cd"] = this.getUrlParameter("client_cd");
    params["store_id"] = this.getUrlParameter("store_id");
    params["visitor_id"] = this.getUrlParameter("visitor_id");
    params["loc"] = this.getUrlParameter("loc");
    params["menubook_id"] = this.getUrlParameter("menubook_id");

    var locals = [];
    locals["client_cd"] = localStorage.getItem("client_cd");
    locals["store_id"] = localStorage.getItem("store_id");
    locals["visitor_id"] = localStorage.getItem("visitor_id");
    locals["loc"] = localStorage.getItem("loc");

    if (params["client_cd"] && params["store_id"] && params["visitor_id"]) {
      // set params
      localStorage.setItem("client_cd", params["client_cd"]);
      localStorage.setItem("store_id", params["store_id"]);
      localStorage.setItem("visitor_id", params["visitor_id"]);
      
      if (params["loc"]){
        localStorage.setItem("loc", params["loc"]);
      } else {
        localStorage.removeItem("loc");
      }

      if (params["menubook_id"]) {
        localStorage.setItem("menubook_id", params["menubook_id"]);
      } else {
        localStorage.removeItem("menubook_id");
      }
      
      return new RouteInfo("redirect", location.protocol + '//' + location.host + location.pathname + "?v=" + Config.version);
    }
    else if (params["client_cd"] && params["store_id"]) {
      // set params
      localStorage.setItem("client_cd", params["client_cd"]);
      localStorage.setItem("store_id", params["store_id"]);
      localStorage.removeItem("visitor_id");
      if (params["loc"]){
        localStorage.setItem("loc", params["loc"]);
      }
      else{
        localStorage.removeItem("loc");
      }
      if (params["menubook_id"]) {
        localStorage.setItem("menubook_id", params["menubook_id"]);
      } else {
        localStorage.removeItem("menubook_id");
      }
      
      return new RouteInfo("redirect", location.protocol + '//' + location.host + location.pathname + "?v=" + Config.version);
    }
    else if (!params["client_cd"] && !params["store_id"] && !params["visitor_id"]) {
      console.log('go here');
      console.log(locals["client_cd"]);
      console.log(locals["store_id"]);
      // no param
      if (!locals["client_cd"] || !locals["store_id"]) {
        return new RouteInfo("page", ErrorPage);
      }
    }

    if (!locals["client_cd"] || !locals["store_id"]) {
      //       Error
      return new RouteInfo("page", ErrorPage);
    }
    if (!locals["visitor_id"]) {
      //      one time
      return new RouteInfo("page", LoginPage);
    }
    return null;
  }

  routeMobile(config:any){
    var params = [];
    params["client_cd"] = this.getUrlParameter("client_cd");
    params["store_id"] = this.getUrlParameter("store_id");
    params["visitor_id"] = this.getUrlParameter("visitor_id");
    params["custom"] = this.getUrlParameter("custom");
    params["stgpay"] = this.getUrlParameter("stgpay");
    params["loc"] = this.getUrlParameter("loc");
    params["debug"] = this.getUrlParameter("debug");
    params["relation_code"] = this.getUrlParameter("relation_code");
    params["menubook_id"] = this.getUrlParameter("menubook_id");
    params["reserved"] = this.getUrlParameter("reserved");
    var locals = [];
    locals["client_cd"] = localStorage.getItem("client_cd");
    locals["store_id"] = localStorage.getItem("store_id");
    locals["visitor_id"] = localStorage.getItem("visitor_id");
    locals["loc"] = localStorage.getItem("loc");
    locals["debug"] = localStorage.getItem("debug");
    locals["menubook_id"] = localStorage.getItem("menubook_id");
    locals["reserved"] = localStorage.getItem("reserved");

    if (params["client_cd"] && params["store_id"] && params["visitor_id"]) {
      // set params
      localStorage.setItem("client_cd", params["client_cd"]);
      localStorage.setItem("store_id", params["store_id"]);
      localStorage.setItem("visitor_id", params["visitor_id"]);
      if (params["loc"]){
        localStorage.setItem("loc", params["loc"]);
      }
      else{
        localStorage.removeItem("loc");
      }
      if (params["menubook_id"]) {
        localStorage.setItem("menubook_id", params["menubook_id"]);
      } else {
        localStorage.removeItem("menubook_id");
      }
      if (params["reserved"]) {
        localStorage.setItem("reserved", params["reserved"]);

        if (params["relation_code"]){
          localStorage.setItem("relation_code", params["relation_code"]);
        }
      } else {
        localStorage.removeItem("reserved");
        localStorage.removeItem("relation_code");
      }

      return new RouteInfo("redirect", location.protocol + '//' + location.host + location.pathname + "?v=" + Config.version);
    }
    else if (params["client_cd"] && params["store_id"]) {
      // set params
      localStorage.setItem("client_cd", params["client_cd"]);
      localStorage.setItem("store_id", params["store_id"]);
      localStorage.removeItem("stgpay");
      localStorage.removeItem("custom");
      localStorage.removeItem("visitor_id");
      localStorage.removeItem("hour");
      localStorage.removeItem("min");
      localStorage.removeItem("note");
      if (params["loc"]){
        localStorage.setItem("loc", params["loc"]);
      }
      else{
        localStorage.removeItem("loc");
      }
      if (params["stgpay"]){
        localStorage.setItem("stgpay", params["stgpay"]);
      }else{
        localStorage.removeItem("stgpay");
      }
      if (params["custom"]){
        localStorage.setItem("custom", params["custom"]);
      }else{
        localStorage.removeItem("custom");
      }
      if (params["debug"]){
        localStorage.setItem("debug", params["debug"]);
      }else{
        localStorage.removeItem("debug");
      }
      if (params["relation_code"]){
        localStorage.setItem("relation_code", params["relation_code"]);
      }else{
        localStorage.removeItem("relation_code");
      }
      // window.document.location.href = location.protocol + '//' + location.host + location.pathname;
      if (params["menubook_id"]) {
        localStorage.setItem("menubook_id", params["menubook_id"]);
      } else {
        localStorage.removeItem("menubook_id");
      }
      if (params["reserved"]) {
        localStorage.setItem("reserved", params["reserved"]);

        if (params["relation_code"]){
          localStorage.setItem("relation_code", params["relation_code"]);
        }
      } else {
        localStorage.removeItem("reserved");
        localStorage.removeItem("relation_code");
      }
      return new RouteInfo("redirect", location.protocol + '//' + location.host + location.pathname + "?v=" + Config.version);
    }
    else if(params["visitor_id"]){
      // success payment
      localStorage.setItem("visitor_id", params["visitor_id"]);
      return new RouteInfo("redirect", location.protocol + '//' + location.host + location.pathname + "?v=" + Config.version);
    }
    else if (!params["client_cd"] && !params["store_id"] && !params["visitor_id"]) {
      console.log('go here');
      console.log(locals["client_cd"]);
      console.log(locals["store_id"]);
      // no param
      if (!locals["client_cd"] || !locals["store_id"]) {
        // this.rootPage = ErrorPage;
        return new RouteInfo("page", ErrorPage);
      }
    }

    if (!locals["client_cd"] || !locals["store_id"]) {
      //       Error
      // this.rootPage = ErrorPage;
      return new RouteInfo("page", ErrorPage);
    }

    return null;
  }

  getUrlParameter(name: string) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? results : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
}



// WEBPACK FOOTER //
// ./src/components/Router.ts